export default __webpack_public_path__ + "static/media/profile-image-placeholder.101a7c46.svg";